export default function filterReviewRateToStars(number: number) {
  return (((number + 2) * 25) / 20).toFixed(1)
}
